import { Link, useLocation } from "react-router-dom";
import { Instagram } from "lucide-react";
import { WHATSAPP_URL } from "../data/content";
import { scrollToId } from "../hooks/useSmoothScroll";
import { useLang } from "../hooks/useLanguage";

const Footer = () => {
  const { pathname } = useLocation();
  const { t } = useLang();
  const home = pathname === "/";

  const go = (id) => {
    if (home) scrollToId(id);
    else window.location.href = `/#${id}`;
  };

  return (
    <footer className="bg-[#141414] text-ivory border-t hairline-dark" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16 md:py-20">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-12">
          <div>
            <p className="latin-text font-serif-lux text-2xl font-light tracking-[0.32em] uppercase">LE Capital</p>
            <p className="mt-3 text-[0.68rem] uppercase tracking-[0.22em] text-champagne">{t.UI.footerTagline}</p>
            <p className="mt-6 text-sm text-ivory/55 leading-relaxed">
              <span className="md:whitespace-nowrap">{t.UI.footerTrading}</span>
              <br />
              {t.UI.footerLocation}
            </p>
          </div>
          <nav aria-label="Footer">
            <p className="text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-ivory/45 mb-5">
              {t.UI.footerExplore}
            </p>
            <ul className="space-y-3">
              {t.NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <a
                    href={home ? `#${l.id}` : `/#${l.id}`}
                    onClick={(e) => {
                      if (home) {
                        e.preventDefault();
                        go(l.id);
                      }
                    }}
                    className="text-sm text-ivory/60 hover:text-champagne transition-colors duration-300 underline-offset-4 hover:underline"
                    data-testid={`footer-link-${l.id}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <button
                  onClick={() => go("consultation")}
                  className="text-sm text-ivory/60 hover:text-champagne transition-colors duration-300 underline-offset-4 hover:underline"
                  data-testid="footer-link-contact"
                >
                  {t.UI.footerContactLink}
                </button>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-ivory/60 hover:text-champagne transition-colors duration-300 underline-offset-4 hover:underline"
                  data-testid="footer-link-privacy"
                >
                  {t.UI.footerPrivacy}
                </Link>
              </li>
            </ul>
          </nav>
          <div>
            <p className="text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-ivory/45 mb-5">
              {t.UI.footerContact}
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block text-sm text-ivory/60 hover:text-champagne transition-colors duration-300 underline-offset-4 hover:underline"
              data-testid="footer-whatsapp"
            >
              {t.UI.footerWhatsapp}
            </a>
            <a
              href="https://www.instagram.com/lecapitaluae"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 flex w-fit items-center gap-2 text-sm text-ivory/60 hover:text-champagne transition-colors duration-300 underline-offset-4 hover:underline"
              data-testid="footer-instagram"
            >
              <Instagram size={15} />
              <span className="latin-text">Instagram</span>
            </a>
          </div>
        </div>
        <p className="mt-16 pt-8 border-t hairline-dark text-xs text-ivory/40 leading-relaxed max-w-4xl" data-testid="footer-disclaimer">
          {t.UI.footerDisclaimer}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row justify-between gap-3 text-xs text-ivory/40">
          <span>© {new Date().getFullYear()} {t.UI.footerCopyright}</span>
          <span>{t.UI.footerLocation}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
